<template>
  <div >
    <span :class="claseError">{{titulo}}</span>
    <span v-if="obligatorio" class="font-weight-bold ml-1" :class="claseError">*</span>
    <IconoInformacion :sInformacion="sInformacion"/>
  
      <v-autocomplete
        class="mt-1"
        v-model="valor"
        :items="comp_get_aItemsFiltro"
        item-text="texto"
        item-value="id"
        :placeholder="Mensaje"
        :loading="loadSelect"
        :disabled="bEditable"
        height="30px"
        clearable
        outlined
        dense
        hide-details
        :error="esError"
        :rules="noVacio">
        <template slot="no-data">
          <div>No hay información</div>
        </template>
        </v-autocomplete>
  </div>
  </template>
  
  <script>
  import axiosServices from "@/services/axiosServices.js"
  import { mapGetters } from 'vuex'
  import FormMixin from '@/mixins/formularioMixin.js'
  import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'
  
  export default {
    name: 'FormSelectFiltro',
    mixins: [FormMixin],
    components: {
      IconoInformacion,
    },
    props: {
      inner:{
        type: String,
        default: ''
      },
      campoFiltro: {    // nombre del campo en la tabla por el cual se filtra
        type: String,
        default: ''
      },
      valorFiltro: {   // Valor por el cual se filtra
        type: String,
        default: ''
      }
    },
    data() {
      return {
        valor           : this.value,
        itemsData       : [],
        loadSelect      : false,
        Mensaje         : 'Cargando..',
        esError         : false,
        noVacio         : [v => !!v],
        bEditable       : (this.editable == "0") ? true : false,
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      async getItems(){
        let sAux = this.inner != null ? this.inner.split(',') : '' 
        this.loadSelect = true
        this.Mensaje = 'Cargando ..'
        const aItems = await axiosServices.getConfiguration('/select_filrado/' + sAux[0] + '/' + this.campo  + '/' + this.campoFiltro , true , (this.bSubdominioTemporal ? `subdominiot=${this.$store.state.sSubdominioTemporal}` : '') )
  
        this.itemsData = aItems.aData
        this.loadSelect = false
        this.Mensaje = 'Seleccione ' + this.titulo
      },
    },
    computed: {
  
      comp_get_aItemsFiltro(){
          return this.itemsData.filter( valor => valor.filtro == this.valorFiltro)
      },
  
      ...mapGetters(['getoFormError'])
    },
    watch: {
      valor(NewValor){
        this.$emit('selectTexto', this.itemsData.find( elemento => elemento.id == NewValor) != undefined ? this.itemsData.find( elemento => elemento.id == NewValor).texto : '')
      },
    },
    
  }
  </script>
  
  <style scoped>
  
  
  </style>